export default __webpack_public_path__ + "static/property-nego-4c49847c8dc3c2ccf3c1551502b00c04.png";